"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _Analytics = _interopRequireDefault(require("../analytics/Analytics"));

var eventTracker = function eventTracker(item) {
  var topicType = item.type === 'discussion' ? 'conversation' : item.type;
  var eventLabel = {
    Type: topicType,
    Position: 'Recommendations list',
    Link: item.url
  };

  _Analytics.default.send('Homepage', 'Topic clicked', eventLabel);

  _publish.default.trackEvent('userevent', {
    type: 'Topic Clicked',
    topic_title: item.title,
    topic_url: item.url,
    topic_position: item.idx + 1,
    // to start index from 1 instead of 0, added +1
    topic_topic_type: topicType,
    click_source: 'Homepage recommendation'
  });
};

var ContentCurationItem = function ContentCurationItem(props) {
  var url = props.url,
      title = props.title,
      icon = props.icon,
      id = props.id;
  return (0, _preact.h)("li", {
    className: "topic-curation__item"
  }, (0, _preact.h)("span", null, " ", icon, " "), (0, _preact.h)("a", {
    "data-topic-id": id,
    className: "topic-curation__item-link link",
    onClick: function onClick() {
      return eventTracker(props);
    },
    href: (0, _absoluteUrlRuntime.resolveUrl)(url)
  }, title));
};

var _default = ContentCurationItem;
exports.default = _default;